<template>
    <div class="main_container">
        <div id="background" :class="{ 'detail_background': selectedNotice !== null }">
            <div v-if="selectedNotice === null">
                <div class="category_container">
                    <div class="category_item" style="flex: 5;">제목</div>
                    <div class="category_item" style="flex: 3;">작성일</div>
                    <div class="category_item" style="flex: 1;">구분</div>
                </div>
                <div v-for="(notice) in displayedNotices" :key="notice.id" class="notice_item" @click="selectNotice(notice.idx)">
                    <div class="notice_info">{{ notice.title }}</div>
                    <div class="notice_date">{{ formatDate(notice.reg_time) }}</div>
                    <div :class="['notice_read', { unread: !notice.isRead }]">{{ notice.isRead ? '읽음' : '안읽음' }}</div>
                </div>
            </div>
            <div v-else>
                <div class="notice_info">
                    <div class="detail_title">
                        <h3>{{ notices[selectedNoticeIndex].title }}</h3>
                        <p class="detail_date">{{ formatDate(notices[selectedNoticeIndex].reg_time) }}</p>
                    </div>
                    <div class="detail_content">
                        <p>{{ notices[selectedNoticeIndex].content }}</p>
                        <button @click="selectedNotice = null" class="back_button">뒤로 가기</button>
                    </div>
                </div>
            </div>
            <div class="pagination" v-if="selectedNotice === null">
                <div class="page_btn_container" style="width: 92px;">
                    <button @click="prevPage" :disabled="currentPage === 1" class="button" v-show="currentPage !== 1">이전</button>
                </div>
                <span class="page_number" style="width: 60px;">{{ currentPage }} / {{ totalPages }}</span>
                <div class="page_btn_container" style="width: 92px;">
                    <button @click="nextPage" :disabled="currentPage === totalPages" class="button" v-show="currentPage !== totalPages">다음</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import store from '../../js/store.js';

export default {
    name: "notice_board",
    data() {
        return {
            notices: store.state.notice_list,
            currentPage: 1,
            pageSize: 10,
            selectedNotice: null, // 공지사항의 idx를 저장하는 변수로 변경
            selectedNoticeIndex: null // 선택된 공지사항의 인덱스
        };
    },
    computed: {
        totalPages() {
            let total = Math.ceil(this.notices.length / this.pageSize);
            return Math.max(total, 1);
        },
        displayedNotices() {
            const unreadNotices = this.notices.filter(notice => !notice.isRead).sort((a, b) => new Date(b.reg_time) - new Date(a.reg_time));
            const readNotices = this.notices.filter(notice => notice.isRead).sort((a, b) => new Date(b.reg_time) - new Date(a.reg_time));
            const sortedNotices = unreadNotices.concat(readNotices);
            
            const start = (this.currentPage - 1) * this.pageSize;
            const end = start + this.pageSize;
            return sortedNotices.slice(start, end);
        }
    },
    methods: {
        formatDate(dateString) {
            const date = new Date(dateString);
            return `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`;
        },
        prevPage() {
            if (this.currentPage > 1) {
                this.currentPage--;
            }
        },
        nextPage() {
            if (this.currentPage < this.totalPages) {
                this.currentPage++;
            }
        },
        selectNotice(idx) {
            // 공지사항의 idx를 선택된 공지사항으로 설정
            this.selectedNotice = idx;
            // 선택된 공지사항의 인덱스를 찾음
            this.selectedNoticeIndex = this.notices.findIndex(notice => notice.idx === idx);
            store.commit('readNotice', idx); // store에 해당 공지사항의 idx를 커밋
            this.notices[this.selectedNoticeIndex].isRead = true; // 공지사항을 클릭하면 읽음으로 표시

            var notRead = false;
            this.notices.forEach(element => {
                if(!element.isRead)
                    notRead = true;
            });
            store.state.notReadExist =  notRead;
        }
    }
};
</script>

<style>
.detail_background {
    background-color: rgba(255, 255, 255, 0.8);
}

.category_container {
    display: flex;
    background-color: #333;
    border-radius: 5px;
    margin-bottom: 20px;
}

.category_item {
    font-size: 16px;
    font-weight: bold;
    color: white;
    text-align: center;
    margin-top: 2px;
    margin-bottom: 2px;
}

.notice_item {
    margin-left: 10px;
    margin-right: 10px;
    display: flex;
    align-items: center;
    margin-bottom: 20px;
    cursor: pointer;
    height: 20px;
}

.notice_category {
    flex: 1;
    font-size: 18px;
    font-weight: bold;
    color: white;
    text-align: center;
}

.notice_info {
    flex: 5;
    margin-left: 20px;
    margin-right: 20px;
    font-size: 16px;
    font-weight: bold;
    color: white;
    margin: 0;
}

.notice_info h3 {
    font-size: 16px;
    font-weight: bold;
    color: white;
    margin: 0;
}

.notice_info p {
    font-size: 18px;
    color: white;
}

.notice_date {
    flex: 3;
    font-size: 18px;
    color: white;
    text-align: center;
}

.notice_read {
    flex: 1;
    font-size: 15px;
    color: white;
    text-align: center;
}

.notice_read.unread {
    font-weight: bold;
    color: yellow;
}

.pagination {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 20px;
}

.button {
    padding: 10px 20px;
    margin: 0 10px;
    font-size: 16px;
    font-weight: bold;
    color: white;
    background-color: #2d88ff;
    border: none;
    border-radius: 5px;
    cursor: pointer;
}

.page_number {
    font-size: 16px;
    font-weight: bold;
    color: white;
}

.back_button {
    padding: 10px 20px;
    margin-top: 20px;
    font-size: 16px;
    font-weight: bold;
    color: white;
    background-color: #2d88ff;
    border: none;
    border-radius: 5px;
    cursor: pointer;
}

.detail_title {
    border-bottom: 2px solid white;
    margin-bottom: 20px;
    padding-bottom: 10px;
}

.detail_date {
    font-size: 14px;
    color: white;
    text-align: right;
}
</style>
